import { render } from "./MemberInfo.vue?vue&type=template&id=4012fee8&scoped=true"
import script from "./MemberInfo.vue?vue&type=script&lang=js"
export * from "./MemberInfo.vue?vue&type=script&lang=js"

import "./MemberInfo.vue?vue&type=style&index=0&id=4012fee8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4012fee8"]])

export default __exports__